// extracted by mini-css-extract-plugin
export default {"bodyBackground":"vpjTd3","navBarContainer":"VAEyTv","navBarTitle":"GQnzDL","navBarIcon":"XJY94_","navBarRightContent":"ekgVX0"};